import React from 'react';
import {Button, Modal, ModalBody, ModalHeader} from 'reactstrap';
import PropTypes from 'prop-types';


export const ProgressHeader = ({ title , step , maxSteps }) => {
    return <div className="clearfix">
        <div className="pull-left">
            <b>{title}</b>
        </div>
        <div className="pull-right">
            <p>Step {step} of {maxSteps}</p>
        </div>
    </div>;
};

class ConfirmUserUpdate extends React.Component{

    static propTypes = {
        title: PropTypes.string,
        large: PropTypes.bool,
        showCancelButton: PropTypes.bool
    };

    static defaultProps = {
        showCancelButton: true
    };

    constructor(props){
        super(props);
        this.state = {
            isOpen: false
        };

        this.toggle = this.toggle.bind(this);
    }

    show(){

        this.setState({
            isOpen: true
        });

    }

    toggle(){

        this.setState({
            isOpen: !this.state.isOpen
        });

    }

    render(){
        return <Modal className={this.props.large ? "modal-lg" : null} isOpen={this.state.isOpen} toggle={this.toggle}>
            <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
            <ModalBody>
                {this.props.children}
                {this.props.showCancelButton && <div className="clearfix">
                    <hr/>

                    <div className="pull-right">
                        <Button color={"link"} onClick={this.toggle}>Cancel</Button>
                    </div>
                </div>}

            </ModalBody>
        </Modal>
    }

}

export default ConfirmUserUpdate;


// WEBPACK FOOTER //
// ./src/components/ConfirmUserUpdate/ConfirmUserUpdate.js